import type { TypeProductMenuCode } from '~/constants/product';

import type { TypeCategoryType, TypeGetSalesChannelParams, TypeGetSkusParams } from '~/types/product.types';

/**
 * [상품관리] React Query Key Factory
 */
export const productKeys = {
  all: ['product'] as const,

  /** 카테고리 타입별 조회 (GET /categories/types/:type) */
  categoriesTypes: (type: TypeCategoryType) => [...productKeys.all, 'categoriesTypes', type] as const,

  /** 상위코드로 하위 카테고리 조회 (GET /categories/codes/:parentCode) */
  categoriesCodes: (parentCode: string | null) => [...productKeys.all, 'categoriesCodes', parentCode] as const,

  /** 공통 코드 조회 (GET /codes/menu/:menuCode) */
  codesMenu: (menuCode: TypeProductMenuCode) => [...productKeys.all, 'codesMenu', menuCode] as const,

  /** 상품 리스트 조회 (GET /third-parties/skus) */
  skus: (params: TypeGetSkusParams) => [...productKeys.all, 'skus', params] as const,

  /** 상품 단건 상세 조회 (GET /third-parties/skus/:skuCode) */
  skuDetail: (skuCode: string) => [...productKeys.all, 'skuDetail', skuCode] as const,

  /** 운영상품 상세 조회 (GET /third-parties/active-skus/:skuCode) */
  activeSkuDetail: (skuCode: string) => [...productKeys.all, 'activeSkuDetail', skuCode] as const,

  /** 상품 판매처 매핑 리스트 조회 (GET /third-parties/sales-channel) */
  salesChannel: (params: TypeGetSalesChannelParams) => [...productKeys.all, 'salesChannel', params] as const,

  /** 판매처 코드 목록 조회 (GET /third-parties/sales-channel/codes) */
  salesChannelCodes: () => [...productKeys.all, 'salesChannelCodes'] as const,

  /** 오더유형 정보 조회 (GET /order-type/info) */
  orderTypeInfo: () => [...productKeys.all, 'orderTypeInfo'] as const,

  /** 화주사코드로 공급사 목록 조회 (GET /suppliers/:consignorCode) */
  suppliersConsignorCode: (consignorCode: string) =>
    [...productKeys.all, 'suppliersConsignorCode', consignorCode] as const,

  /** 상품코드 조회 (GET /goods-commerce-fbk/:skuCode) */
  goodsCommerceFbkSkuCode: (skuCode: string) => [...productKeys.all, 'goodsCommerceFbkSkuCode', skuCode] as const,
};
